/**
 * FloatingLabelTextInput Component Entry Point
 *
 * Re-exports the `FloatingLabelTextInput` component and its props for easier imports.
 * This allows consumers to import from the component directory directly:
 * 
 * Example:
 * import { FloatingLabelTextInput, FloatingLabelTextInputProps } from "@geekyhawks/react-native-ui-components";
 *
 * Author: Geeky Hawks FZE LLC
 */

export { default as FloatingLabelTextInput } from "./FloatingLabelTextInput";
export type { Props as FloatingLabelTextInputProps } from "./FloatingLabelTextInput";
